import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { BillingList } from "@/components/billing/BillingList";
import { BillingSummary } from "@/components/billing/BillingSummary";
import { InvoicesTab } from "@/components/billing/InvoicesTab";

export default function Billing() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "list";
  return (
    <>
      <PageHeader title="Facturation" subtitle="Suivi des prestations à facturer et récapitulatif des heures. Aucune facture n'est créée ni envoyée." />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="bg-[#122549]">
          <TabsTrigger value="list" data-testid="billing-tab-list">À facturer</TabsTrigger>
          <TabsTrigger value="summary" data-testid="billing-tab-summary">Récapitulatif</TabsTrigger>
          <TabsTrigger value="payments" data-testid="billing-tab-payments">Règlements</TabsTrigger>
        </TabsList>
        <TabsContent value="list" className="mt-4"><BillingList /></TabsContent>
        <TabsContent value="summary" className="mt-4"><BillingSummary /></TabsContent>
        <TabsContent value="payments" className="mt-4"><InvoicesTab initialStatus={params.get("pay") || "open"} /></TabsContent>
      </Tabs>
    </>
  );
}
